<template>
  <v-list two-line>
    <v-subheader v-if="title">{{title}}</v-subheader>
    <v-list-tile
      v-for="tournee in tournees"
      :key="`tournee-${tournee.id}`"
      avatar
      ripple 
      :to="`tournee/${tournee.id}`"
      :active-class="$style['tournee-selected']"
    >
      <!-- :to="'#'+tournee.id+isMobileHash" -->
      <v-list-tile-avatar :color="tournee.couleur">
        <span class="white--text headline">{{tournee.libelle[0]}}</span>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>
          <v-layout justify-space-between row >
            <v-flex>{{tournee.libelle}}</v-flex>
            <v-flex :class="[$style.date, 'text-xs-right']">{{tournee.datePassage | date}}</v-flex>
          </v-layout>
        </v-list-tile-title>
        <v-list-tile-sub-title v-if="tournee.prochaineDate != '01/01/0001'" class="text-xs-right">Prochain passage : {{tournee.prochaineDate | date}}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <slot name="no-data" v-if="!tournees.length"></slot>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    idTournee: Number,
    title: String,
    // typeVisu sert à gérer différente manière d'afficher la liste
    // - typeVisu: '' -> afficher toute la liste filtrée
    // - typeVisu: 'aujourdhui' -> affiche que la tournée du jour en fonction du filtre activé
    // - typeVisu: 'suivante' -> affiche que les prochaines tournées en fonction du filtre activé
    typeVisu: String
  },
  computed: {
    tournees(){
      const { filteredTournee = [] } = this
      switch (this.typeVisu) {
        case 'aujourdhui':
              return filteredTournee.filter(e => e.datePassage == (new Date()).toISOString().substr(0, 10).split("-").reverse().join("/"))
        case 'suivante': 
          // eslint-disable-next-line no-case-declarations
          const sortFilteredTournee = [...filteredTournee]
          sortFilteredTournee.sort((a,b)=>{
            const dateA = a.datePassage.split("/").reverse().join("")
            const dateB = b.datePassage.split("/").reverse().join("")
            return +dateA - +dateB
          })
          return sortFilteredTournee.filter(e => {
              const datePassage = +e.datePassage.split("/").reverse().join("")
              //const dateDuJour = (new Date()).toLocaleDateString().trim().split("/").reverse().join("")
              const dateDuJour = (new Date()).toISOString().substr(0, 10).split("-").join("")
              return +datePassage > +dateDuJour
          }).slice(0,5)
        }       
      return filteredTournee
    },
    ...mapGetters(['filteredTournee'])
  },
  filters: {
    date(pDate){
      return pDate == '01/01/0001' ? '' : pDate
    }
  }
}
</script>

<style module>
.date{
  max-width: 90px;
}
a.tournee-selected {
  background-color: rgba(0,0,0,0.10);
}
</style>

